import React, { type InputHTMLAttributes, useId } from 'react'
import styles from './inputCheck.module.scss'

// eslint-disable-next-line @typescript-eslint/consistent-type-definitions -- Props extends a DOM attributes interface; interface extension is idiomatic here
export interface InputCheckProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string
  labelClassName?: string
  error?: boolean
  checked: boolean
  labelPos?: 'left' | 'right'
}

export const InputCheck = ({
  label,
  labelClassName,
  error,
  className,
  labelPos = 'right',
  ...props
}: InputCheckProps) => {
  const genId = useId()
  const classes = [
    className ?? '',
    styles['input-check'],
    'modul',
    'row-flx',
    'flx-a-c',
    error ? styles['input-check--error'] : '',
  ].filter(Boolean).join(' ')

  const labelClass = `${labelClassName ?? 'txt-p-2 txt-p-2-s'} ${labelPos === 'left' ? 'm-r-8' : 'm-l-8'}`

  return (
    <div className={classes}>
      {label != null && labelPos === 'left' && (
        <label className={labelClass} htmlFor={props.id ?? genId}>{label}</label>
      )}
      <input className="input checkbox" type="checkbox" id={props.id ?? genId} {...props} />
      {label != null && labelPos === 'right' && (
        <label className={labelClass} htmlFor={props.id ?? genId}>{label}</label>
      )}
    </div>
  )
}
